import { gql } from 'graphql-tag';

const fishingWaterReviewId = gql`
  fragment FishingWaterReviewId on FishingWaterReview {
    _id: externalId
  }
`;

/**
 * Note: FishingWaterReviewNodeFields depends on PostFragments.id (PostId)
 * and UserFragments.id (UserId). To avoid circular imports, those dependencies
 * are NOT included here. The query that uses this fragment must include them.
 */
const fishingWaterReviewNodeFields = gql`
  fragment FishingWaterReviewNodeFields on FishingWaterReview {
    ...FishingWaterReviewId
    externalId
    rating
    createdAt
    author {
      ...UserId
      nickname
      lastName
      firstName
    }
    post {
      ...PostId
      helpfulDownvotesCount
      helpfulUpvotesCount
      currentUserFoundHelpful
      titleString
      text {
        text
      }
    }
  }
  ${fishingWaterReviewId}
`;

export const FishingWaterReviewFragments = {
  id: fishingWaterReviewId,
  reviewNodeFields: fishingWaterReviewNodeFields,
  allReviewsFields: gql`
    fragment FishingWaterDetailAllReviewsFields on ReviewInterfaceRecordConnection {
      totalCount
      totalAverage(attribute: RATING)
    }
  `,
  amenityNodeFields: gql`
    fragment FishingWaterDetailAmenityNodeFields on FishingWaterReviewPropertyQuestion {
      __typename
      summaryHeader
    }
  `,
};
